var React = require('react');

function CheckMarkIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"29.9998","cy":"30","r":"25.2","fill":"#00C8A9","key":0}),React.createElement("path",{"d":"M51.9167 12.2285L25.7684 39.0882L15.5709 28.8694","stroke":"black","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckMarkIcon.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = CheckMarkIcon;

CheckMarkIcon.default = CheckMarkIcon;
